const React = require('react');
const ReactDOM = require('react-dom/client');
const Layout = require('./src/components/Shared/Layout').default;
const { captureFirstTouch } = require('./src/utils/getFirstTouchAttribution');

// Runs once, before the app renders anything — must happen here rather than in a component
// lifecycle (e.g. Layout's componentDidMount), because React finishes rendering the whole page,
// including GetQuoteModal reading this data for its initial state, before any componentDidMount
// fires. Capturing it post-render would be one render too late on a visitor's first page.
exports.onClientEntry = () => {
  captureFirstTouch();
};

exports.replaceHydrateFunction = () => (element, container) => {
  const root = ReactDOM.createRoot(container);
  root.render(element);
};

exports.wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>;
};
